import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
// import './assets/js/main.js'; // Commented out - causes hot reload issues (re-executes on every save)
import './assets/css/all.css';
import './assets/css/client-style.css';
import './assets/font-awesome/css/font-awesome.css';
import { useEffect, useRef, useState } from 'react';
import Footer         from './components/footer/Footer';
import Header         from './components/header/Header';
import Accessibility  from './pages/accessibility/Accessibility';
import Account        from './pages/account/Account';
import Contactus      from './pages/contactus/Contactus';
import Home           from './pages/home/Home';
import Login          from './pages/login/Login';
import Privacy        from './pages/privacy/Privacy';
import Terms          from './pages/terms/Terms';
import AccountVolunteering from './components/account-volunteering/AccountVolunteering';
import ErrorPage from './pages/error_page/ErrorPage';
import checkConnected from './services/check-connected/checkConnected';
import Loader from './components/loader/Loader';
import logout from './services/logout/logout';
import axios from 'axios';
import logoutAndSaveUrl from './services/logout/logoutAndSaveUrl';
import ProjectContent from './pages/ProjectContent/ProjectContent';
import LikedProjects from './pages/liked-projects/LikedProjects';
import OpenForm from './pages/open-form/OpenForm';
import CrmUtils from './services/crm-utils/CrmUtils';
import {clearAll, setHeaderMainLink, setRdxPartner, setUserDetails} from './services/store/GenericReducer.js';
import { useDispatch } from 'react-redux';
import Cookies from "universal-cookie";
import GlobalTexts from './components/global/GlobalTexts.jsx';

function App() {
  const [partner, setPartner] = useState({})
  const loaderColor = "#f78e1e"
  const location = useLocation()
  const partnerName = location.pathname.split("/")[1]
  const dispatch = useDispatch()
  
  const getMainPartner = async() => {
      setPartner(GlobalTexts());
  }

  useEffect(() => {
      dispatch(setRdxPartner(partner))
  }, [partner])

  useEffect(() => {
    dispatch(setHeaderMainLink(true))
  }, [location])

  let finalMount = useRef(true)
  useEffect(() => {
    if(finalMount.current){
      finalMount.current = false
      getMainPartner(true, partnerName)
    }
  },[])

  return (
    <>
    { ("partnerID" in partner) ? 
	    <div className="wrapper main-page">
      <Header partner={partner}/>
        
        <Routes>
          {/* <Route path={`/login`} element={ <Login partner={partner} manageToken={manageToken}/> } /> */}
          <Route path={`/`} element={ <Home partner={partner}/> } />
          {/* <Route path={`/contactus`} element={ <Contactus partner={partner}/> } /> */}
          {/* <Route path={`/faq`} element={ <Faq/> } /> */}
          {/* <Route path={`/accessibility`} element={ <Accessibility/> } />
          <Route path={`/contract`} element={ <Terms/> } />
          <Route path={`/privacy`} element={ <Privacy/> } /> */}

          <Route path={`/liked-projects`} element={ <LikedProjects partner={partner}/> } />
          <Route path={`/project/:id`} element={ <ProjectContent partner={partner}/> } />
          <Route path={`/open-form`} element={ <OpenForm partner={partner}/> } />
          <Route path={`/error`} element={ <ErrorPage/>} />
          <Route path={`/*`} element={ <ErrorPage/>} />
        </Routes>

        {/* <Thankyou title="איזה כיף שבחרת להתנדב!" msg="יועצי ההתנדבות שלנו יחזרו אליך להמשך התהליך. אם ייקח לנו כמה ימים זה בגלל שיש עוד אנשים טובים כמוך (:
        "/> */}
       <Footer partner={partner}/>
      </div>  
     : <Loader showLoader={true} color={loaderColor}/>
    }
    </>
  );
}

export default App;

